// Core
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { restAPIs } from 'utils/restAPIs';
import { fetchData } from 'utils/fetch';
import InputField from 'components/commonComponents/InputField';

// Styles
import './styles.scss';
import validator from 'validator';
import Otp from '../Otp';
import { useAlert } from 'hooks/useAlert';
import FormDialog from 'components/commonComponents/FormDialog';

const ForgotPassword = (props) => {
  const { onClose, open } = props;
  const { t } = useTranslation();
  const [dataSet, setData] = useState({});
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { email } = dataSet;
  const { errorAlert, setErrorAlert, showAlert } = useAlert();
  const [openOtp, setOpenOtp] =  useState(false);

  const handleOnChange = (key) => (_value) => {
    if (_value) {
      setError({
        ...error,
        [key]: null
      });
    }
    setData({
      ...dataSet,
      [key]: _value
    });
  };


  const handleSave = async () => {
    const errors = {
      email: !validator.isEmail(email) && 'Enter valid email',
    };

    setError(errors);
    let isFormValid = Object.values(errors).every((item) => !item);
    if (!isFormValid) return;
    setIsLoading(true);
    const formData = new FormData();
    formData.append('email', email)
    formData.append('appId', '29')
    const res = await fetchData(restAPIs.forgotPassword(formData));
    if (res.statusCode === 200) {
      setError({});
      setOpenOtp(true);
    } else {
      showAlert(res.errormessage, 'error');
    }
    setIsLoading(false);
  };

  const handleCloseForgot = (event, reason) => {
    setData({});
    setError({});
    setErrorAlert({})

    if (reason === "backdropClick") {
      console.log(reason);
    } else {
      onClose();
    }
  };

  const handleCloseOtp = () => {
    setOpenOtp(false);
};

  return (
    <FormDialog
        open={open}
        onClose={handleCloseForgot}
        title={t('forgot_password')}
        onSubmit={handleSave}
        loading={isLoading}
        alert={errorAlert}
        extra={<><Otp open={openOtp} onClose={handleCloseOtp} email={email} type={'forgot'}/></>}
      >
          <div className='mt-2'>
            <InputField
              onChange={handleOnChange('email')}
              value={email}
              placeholder={t('enter_your_email_address')}
              type='email'
              label={t('email')}
              error={error.email}
            />
          </div>
      </FormDialog>
  );
};

export default ForgotPassword;

ForgotPassword.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
};
